const state = {
  pageData: {},
  xx: '',
  fileList: JSON.parse(sessionStorage.getItem('fileList')) || {}
}
const mutations = {
  SETPAGEDATA: (state, value) => {
    state.pageData = value
  },
  SETFILELIST: (state, value) => {
    state.fileList = value
    sessionStorage.setItem('fileList', JSON.stringify(value))
  },
  setxx: (state, value) => {
    state.xx = value
  },
}
export default {
  namespaced: true,
  state,
  mutations,
}
